export default {
  nav: {
    product: 'Product',
    solutions: 'Solutions',
    terminals: 'Terminals',
    cases: 'Cases',
    pricing: 'Pricing',
    contact: 'Contact Sales',
    admin: 'Admin Portal',
    client: 'Client Portal',
    pda: 'PDA Download',
    portal: 'Portal',
    portalAdmin: 'Admin Console',
    portalClient: 'Customer Portal',
    portalAdminDesc: 'Internal staff workspace',
    portalClientDesc: 'Sign in for customers'
  },
  hero: {
    badge: 'End-to-end cross-border logistics digitization',
    title: 'Make global freight flow',
    titleHighlight: 'as clear as local',
    subtitle: 'JMTMS is a TMS + WMS SaaS platform built for cross-border logistics. From order placement, warehouse receiving, ocean booking, load planning to last-mile delivery and financial settlement — all connected in one network.',
    ctaPrimary: 'Book a Demo',
    ctaSecondary: 'Explore Features',
    stats: {
      efficiency: 'Order processing efficiency up',
      efficiencyValue: '60%',
      accuracy: 'Carton data accuracy',
      accuracyValue: '98%',
      coverage: 'Business nodes covered',
      coverageValue: '8+'
    }
  },
  product: {
    eyebrow: 'Capabilities',
    title: 'One system for transport and warehouse',
    subtitle: 'Stop letting TMS and WMS work in silos. JMTMS weaves waybills, cartons, inventory, load plans and finance into a single network.',
    modules: {
      customer: {
        title: 'Customer & Channel',
        desc: 'Direct clients and forwarders, SKU library, certification docs, API integration — 80% faster onboarding.'
      },
      waybill: {
        title: 'Waybill Management',
        desc: 'Full lifecycle waybill management, AI OCR, 55+ filter dimensions, 20+ auto-validation rules.'
      },
      execution: {
        title: 'Freight Execution',
        desc: 'Sailing schedule, agent quoting, smart load planning and container tracking — 30% shorter planning cycle.'
      },
      warehouse: {
        title: 'Warehouse WMS',
        desc: 'Warehouse / zone / location visualization, receiving, picking, inventory and aging alerts — 20% better space usage.'
      },
      finance: {
        title: 'Finance & Settlement',
        desc: 'Waybill audit lock, three-layer audit for receivables / costs / commissions, near-zero reconciliation errors.'
      },
      monitor: {
        title: 'Monitoring Center',
        desc: 'DW delivery-window compliance, 8-node track-and-trace, automated Amazon performance alerts.'
      }
    }
  },
  terminals: {
    eyebrow: 'Three-terminal synergy',
    title: 'The right interface for every role',
    subtitle: 'Admin web, client portal and PDA handheld stay in sync — at the office, the warehouse or the terminal.',
    admin: {
      tag: 'Admin',
      title: 'Command center for operations',
      desc: 'Sales, customer service, operations and finance collaborate on one platform. Customer management, waybill processing, booking comparison, load scheduling, financial audit and monitoring alerts — all visualized.',
      cta: 'Open Admin Portal'
    },
    client: {
      tag: 'Client',
      title: 'Self-service client portal',
      desc: 'Direct clients and forwarders can place orders, track shipments, reconcile bills, manage SKU and address libraries 24/7.',
      cta: 'Open Client Portal'
    },
    pda: {
      tag: 'PDA Handheld',
      title: 'Warehouse in your palm',
      desc: 'Receiving, scan-to-pick, loading confirmation, exception reporting and location management — fully mobile and synced with admin.',
      cta: 'Android Download',
      scanTip: 'Scan to download PDA App'
    }
  },
  solutions: {
    eyebrow: 'Solutions',
    title: 'Designed for FBA and cross-border lines',
    subtitle: 'From Amazon compliance to smart load planning, every scenario is battle-tested in real operations.',
    items: {
      amazon: {
        title: 'Amazon FBA Compliance',
        desc: 'Two-way data interconnection, automated DW window monitoring, track-and-trace sync checks for Amazon’s four key metrics.'
      },
      consolidation: {
        title: 'Smart Load Planning',
        desc: 'LCL and FCL load planning, real-time loading rate calculation, green highlight at ≥95% to maximize space.'
      },
      visibility: {
        title: 'End-to-end Visibility',
        desc: 'Three-column comparison of client data, picking data and revised data — shipment status at a glance.'
      },
      ecosystem: {
        title: 'Partner Ecosystem',
        desc: 'Deep integration with YunDang, GeoSmart, Mojia, Amazon and Huolala — data flows back automatically.'
      }
    }
  },
  stats: {
    title: 'Data-driven cross-border logistics',
    subtitle: 'Every process improvement turns into measurable business outcomes.',
    items: {
      efficiency: { value: '60%', label: 'Order efficiency up' },
      load: { value: '95%', label: 'Loading rate threshold' },
      inventory: { value: 'T+0', label: 'Inventory real-time' },
      audit: { value: '3', label: 'Finance audit layers' }
    }
  },
  cta: {
    title: 'Start a new rhythm for your logistics',
    subtitle: 'Book a 30-minute product demo and see how JMTMS helps your team work less overtime, make fewer mistakes and earn more.',
    primary: 'Book a Demo',
    secondary: 'Contact Sales'
  },
  footer: {
    slogan: 'Make global freight flow as clear as local',
    copyright: '© 2026 JMTMS. All rights reserved.',
    icp: '粤ICP备2023013524号-2',
    links: {
      product: 'Product',
      solutions: 'Solutions',
      docs: 'Docs',
      privacy: 'Privacy',
      terms: 'Terms'
    }
  },
  language: {
    zh: '中文',
    en: 'English'
  }
}
